import { render, staticRenderFns } from "./updatePortMapping.vue?vue&type=template&id=9b6373f8&scoped=true"
import script from "./updatePortMapping.vue?vue&type=script&lang=js"
export * from "./updatePortMapping.vue?vue&type=script&lang=js"
import style0 from "./updatePortMapping.vue?vue&type=style&index=0&id=9b6373f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b6373f8",
  null
  
)

export default component.exports